import { render, staticRenderFns } from "./fileinfomodel.vue?vue&type=template&id=250877f5&scoped=true&"
import script from "./fileinfomodel.vue?vue&type=script&lang=js&"
export * from "./fileinfomodel.vue?vue&type=script&lang=js&"
import style0 from "./fileinfomodel.vue?vue&type=style&index=0&id=250877f5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "250877f5",
  null
  
)

export default component.exports